import { Box, Text } from '@air/zephyr';
import Image from 'next/image';

import { AgencyContainer } from '~/old-marketing/components/agency/AgencyContainer';

export const AgencyHero = () => {
  return (
    <>
      <Box
        as="section"
        tx={{ zIndex: 1, position: 'relative', backgroundColor: '#0F009E', pt: ['30vw', '10vw'], overflow: 'hidden' }}
      >
        <Box>
          <Text
            as="h1"
            tx={{
              mb: '-3vw',
              fontSize: '11.2vw',
              fontFamily: 'Brice-SemiBoldExpanded',
              letterSpacing: 'unset',
              lineHeight: 1,
              color: 'macaw350',
              textTransform: 'uppercase',
            }}
          >
            The
            <br />
            agency
            <br />
            directory
          </Text>
        </Box>
        <Box tx={{ position: 'absolute', top: 0, right: 0, width: ['40vw', '30vw', 'unset'] }}>
          <Image height={428} src="/assets/marketing/agency-hero-moon.png" width={467} />
        </Box>
        <Box tx={{ zIndex: -1, position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
          <Image height={722} src="/assets/marketing/agency-hero-swirls.svg" width={1462} />
        </Box>
      </Box>

      <Box as="section" tx={{ backgroundColor: 'macaw350', pt: [72, 88], pb: [0, 112] }}>
        <AgencyContainer tx={{ display: 'flex', flexDirection: ['column', 'row'] }}>
          <Box tx={{ position: 'relative', order: [2, 1], width: ['100%', '50%'], mr: 80 }}>
            <Box tx={{ mt: [24, '-2vw'], mb: '-18vw', textAlign: 'center' }}>
              <Image height={420} src="/assets/marketing/agency-hero-cat.png" width={448} />
            </Box>
          </Box>
          <Box tx={{ order: [1, 2], width: ['100%', '50%'] }}>
            <Text
              as="h2"
              tx={{
                mb: [32, 16],
                color: 'macaw060',
                fontFamily: ['Brice-SemiBoldSemiExpanded', 'Brice-SemiBoldSemiExpanded'],
                lineHeight: ['1.3', '1.3'],
                letterSpacing: ['0.03em', '0.03em'],
              }}
              variant={['text-heading-24', 'text-heading-32']}
            >
              Take your brand to new heights. Find the right agency for you.
            </Text>
            <Text as="p" tx={{ color: 'white', fontWeight: 'medium' }} variant={['text-ui-18', 'text-ui-20']}>
              The Agency Directory is a comprehensive database of creative, advertising, marketing, web design, and PR
              agencies from across the map. Browse our list of 1000+ agencies to find the perfect one for you.
            </Text>
          </Box>
        </AgencyContainer>
      </Box>
    </>
  );
};
